module.exports = __webpack_public_path__ + "img/custId.fe8c6d77.png";